import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AssemblyCataloguePicture from "../AssemblyCataloguePicture";

export default function HomeMagneticStory() {
  return (
    <section id="magnetic-difference" className="home-magnetic" aria-labelledby="home-magnetic-heading">
      <div className="home-magnetic__inner">
        <motion.div
          className="home-magnetic__visual"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.55 }}
        >
          <AssemblyCataloguePicture className="home-magnetic__image" />
        </motion.div>
        <motion.div
          className="home-magnetic__copy"
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.55, delay: 0.08 }}
        >
          <p className="lux-eyebrow">The magnetic difference</p>
          <h2 id="home-magnetic-heading" className="lux-h2">
            A box that lifts the whole experience
          </h2>
          <p className="home-magnetic__lead">
            Our rigid magnetic gift boxes snap open with a satisfying feel — presentation that
            matches what is inside. Reusable, display-worthy, and built for that first unboxing
            moment.
          </p>
          <ul className="home-magnetic__list">
            <li>Magnetic box with a premium, repeatable snap</li>
            <li>Rigid keepsake box your recipient can reuse</li>
            <li>Ribbon finish and gift-ready presentation</li>
            <li>Personalised messages on your box at checkout</li>
          </ul>
          <Link to="/catalogue" className="lux-btn lux-btn--primary">
            View assembly instructions
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
